import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { API_URL } from '../../utils/api';
import { currentLocale } from '../../i18n';
import './Tournaments.css';

/**
 * Banner showing active/upcoming tournaments on the dashboard.
 * Only renders if there are tournaments with status scheduled, registration_open, or in_progress.
 */
export default function TournamentBanner() {
  const { t } = useTranslation();
  const [tournaments, setTournaments] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetch(`${API_URL}/api/tournaments`)
      .then((r) => (r.ok ? r.json() : []))
      .then((data) => {
        const active = data.filter(
          (t) => t.status === 'scheduled' || t.status === 'registration_open' || t.status === 'in_progress'
        );
        setTournaments(active);
      })
      .catch(() => {});
  }, []);

  if (tournaments.length === 0) return null;

  return (
    <div className="tournament-banner">
      {tournaments.map((tour) => (
        <div
          key={tour.id}
          onClick={() => navigate(`/tournaments/${tour.id}`)}
          className="tournament-banner-card"
        >
          <div>
            <div className="tournament-banner-name">
              {tour.name}
            </div>
            <div className="tournament-banner-meta">
              {tour.team_size}v{tour.team_size}
              {' '}{tour.format === 'double_elim' ? t('tournament.doubleElimFull') : t('tournament.singleElimFull')}
              {' — '}{tour.match_type}
              {tour.starts_at && (
                <span> — {t('tournament.startPrefix', { date: new Date(tour.starts_at).toLocaleString(currentLocale()) })}</span>
              )}
            </div>
          </div>
          <div className="tournament-banner-right">
            <div
              className="tournament-banner-status"
              style={{ color: tour.status === 'registration_open' ? 'var(--accent-green)' : 'var(--accent-blue)' }}
            >
              {tour.status === 'scheduled' ? t('tournament.statusUpcoming') : tour.status === 'registration_open' ? t('tournament.statusRegOpen') : t('tournament.statusInProgress')}
            </div>
            <div className="tournament-banner-count">
              {t('tournament.registered', { count: tour.registration_count, max: tour.max_slots })}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
